'use client';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from '@/store';
import { ThemeProvider } from '@web/theme';

import { RouteProvider } from './providers/RouteProvider';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <RouteProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>{children}</ThemeProvider>
        </PersistGate>
      </Provider>
    </RouteProvider>
  );
}
